import { Koi } from '@ksyos/koi';
import { DefaultFinancialLogMutationReasons } from '../enums/defaultFinancialLogMutationReasons';

export const freeOfChargeModalValidated = {
    schema: Koi.object().keys({
        explanation: Koi.when('reason', {
            is: DefaultFinancialLogMutationReasons.other,
            otherwise: Koi.valid(null),
            then: Koi.string().max(255).disallow('').required(),
        }),
        reason: Koi.koi().enum(DefaultFinancialLogMutationReasons),
    }),
};
